import {create} from 'zustand'

interface PortalState {
  portalContainerRef: HTMLDivElement | null
  setContainerNode: (node: HTMLDivElement | null) => void
}

export const usePortalStore = create<PortalState>()((set) => ({
  portalContainerRef: null,
  setContainerNode: (node) => {
    set({portalContainerRef: node})
  },
}))
